export default "__VITE_ASSET__DJHjzLZL__"